import React, { ReactNode } from 'react';

const Status = ({
	width,
	img,
	heading,
	content,
	className,
	contentWrapClassName,
}: {
	width?: number | string;
	img?: ReactNode;
	heading?: ReactNode;
	content?: ReactNode;
	className?: string;
	contentWrapClassName?: string;
}) => (
	<div
		className={`c-window ${className || 'p-8'} w-full my-auto`}
		style={{
			maxWidth: width || '100%',
		}}
	>
		<div
			className={`text-center text-base ${
				contentWrapClassName || 'mt-4 pb-8'
			}`}
		>
			{img}
			<h3 className="my-8 text-lg font-bold">{heading}</h3>
			{content}
		</div>
	</div>
);

export default Status;
